module.exports = __webpack_public_path__ + "img/address-book-icon.07fedb94.svg";